module.exports = __webpack_public_path__ + "assets/img/White_Online.b582ab9a.svg";